module.exports = __webpack_public_path__ + "img/chris_frieder_raichle.020f9d3f.jpg";